// Sotto la scheda prodotto nel negozio: garanzia Rarifex e altre creazioni della stessa bottega
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Headphones, RotateCcw, ShieldCheck, Truck } from 'lucide-react';
import { dispatchLabel, loadShopShipping, shippingHeadline } from '../lib/shopPolicies';
import { useShop } from './ShopContext';
import ShopProductCard from './ShopProductCard';
import { GhostLink, RarifexMark } from './ShopUi';

export default function ShopProductExtras({ product }) {
  const { products, name, style, paths, crafter, branding, collections, menuKeys } = useShop();
  const inCollections = menuKeys.includes('collezioni') ? collections.filter((c) => c.products.some((p) => p.id === product?.id)) : [];
  const [shipping, setShipping] = useState(null);
  useEffect(() => {
    let active = true;
    loadShopShipping(crafter.id).then((d) => active && setShipping(d));
    return () => { active = false; };
  }, [crafter.id]);
  const headline = shippingHeadline(shipping);
  const dispatch = dispatchLabel(branding.policies?.dispatch_days);
  const others = products.filter((p) => p.id !== product?.id).slice(0, style.id === 'catalogo' ? 5 : 4);

  return (
    <div className="max-w-6xl mx-auto px-4 pb-16" data-testid="shop-product-extras">
      {inCollections.length > 0 && (
        <p className="mb-4 text-sm text-slate-600 flex flex-wrap items-center gap-x-2 gap-y-1" data-testid="shop-product-collections">
          <span>Fa parte {inCollections.length === 1 ? 'della collezione' : 'delle collezioni'}</span>
          {inCollections.map((c) => (
            <Link key={c.id} to={paths.page(`collezioni/${c.slug}`)} className="inline-flex items-center px-3 py-1 rounded-full border border-shop-primary/30 text-shop-primary hover:bg-shop-primary/5">
              {c.title}
            </Link>
          ))}
        </p>
      )}

      {/* Spedizione e resi della bottega in breve */}
      <div className="mb-6 flex flex-col md:flex-row md:items-center gap-3 md:gap-6 text-sm text-slate-600 border-y border-slate-200 py-4" data-testid="shop-product-shipping">
        {headline && <p className="flex items-center gap-2"><Truck className="w-4 h-4 text-shop-primary shrink-0" /> Spedizione {headline}</p>}
        {dispatch && <p className="flex items-center gap-2"><Clock className="w-4 h-4 text-shop-primary shrink-0" /> Se disponibile, parte {dispatch}</p>}
        <p className="flex items-center gap-2"><RotateCcw className="w-4 h-4 text-shop-primary shrink-0" /> Reso entro 14 giorni, se non personalizzata</p>
        <Link to={paths.page('spedizioni-resi')} className="md:ml-auto shrink-0"><GhostLink className="whitespace-nowrap">Spedizioni e resi <ArrowRight className="w-4 h-4" /></GhostLink></Link>
      </div>

      <div className={`${style.panel} border border-slate-200 bg-white p-5 md:p-6 grid md:grid-cols-[auto_1fr] gap-4 md:gap-8 items-center`} data-testid="shop-guarantee">
        <div className="text-slate-900">
          <p className="text-xs uppercase tracking-widest text-slate-500">Acquisto protetto da</p>
          <RarifexMark className="mt-1 text-base [&>span:first-child]:border [&>span:first-child]:border-slate-200" />
        </div>
        <div className="grid sm:grid-cols-3 gap-4 text-sm text-slate-600">
          <p className="flex gap-2"><ShieldCheck className="w-5 h-5 text-shop-primary shrink-0" /> Pagamento sicuro: i dati della carta non passano dalla bottega.</p>
          <p className="flex gap-2"><Truck className="w-5 h-5 text-shop-primary shrink-0" /> Ordine tracciato dalla preparazione alla consegna.</p>
          <p className="flex gap-2"><Headphones className="w-5 h-5 text-shop-primary shrink-0" /> Assistenza Rarifex se qualcosa va storto.</p>
        </div>
      </div>

      {others.length > 0 && (
        <section className="mt-14">
          <div className="flex items-end justify-between gap-4 mb-6">
            <h2 className={`${style.heading} text-2xl md:text-3xl text-slate-900`}>Altre creazioni di {name}</h2>
            <Link to={paths.page('prodotti')}><GhostLink>Tutte <ArrowRight className="w-4 h-4" /></GhostLink></Link>
          </div>
          <div className={style.id === 'galleria' ? 'grid grid-cols-2 lg:grid-cols-4 gap-6' : style.grid.replace('lg:grid-cols-3', 'lg:grid-cols-4')}>
            {others.map((p) => <ShopProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}
    </div>
  );
}
